import { cn } from "@/lib/utils";
import React from "react";

const SecTitle = ({
  title = "",
  subtitle = "",
  pt = 0,
  pb = 0,
  rightComponent = <></>,
  titleColor = "text-foreground",
  titlevariant = "text-sm", // Tailwind text size class
  subtitlevariant = "text-sm",
  showValidationMessage = false,
  message = null,
  required = false,
  style = {},
  rightComponentClass,
  flex = 'flex-1'
}) => {
  return (
    <div
      className={cn("relative flex flex-row w-full items-start justify-between gap-[6px] text-left text-foreground font-sans", flex, rightComponentClass)}
      style={{
        paddingTop: pt,
        paddingBottom: pb,
        ...style
      }}
    >
      <div className={`flex flex-col ${subtitle ? "gap-[10px]" : "gap-0"}`}>
        <b
          className={`${titlevariant} ${titleColor || 'inherit'}`}
          style={{ color: titleColor || "inherit" }}
        >
          {title}
          {required && <span className="text-red-500"> *</span>}
          {showValidationMessage && (
            <b
              className={`${titlevariant} text-red-500 text-[12px] font-sans ml-[10px]`}
            >
              {message}
            </b>
          )}
        </b>

        {subtitle && (
          <div className="relative text-foreground">
            <p className={`${subtitlevariant} text-[color:var(--tw-prose-body)]`}>
              {subtitle}
            </p>
          </div>
        )}
      </div>

      {rightComponent}
    </div>
  );
};

export default SecTitle;
